import { AppointmentDetailsContent } from "./appointment-detail";
import { EncounterMedicationRefillDetails } from "./refill-details";
import { ConsultationDetailsContent } from "./consultation-details";
import { FormattedEncounter } from "../types";
import { Sheet, SheetContent } from "@workspace/web-ui/components/sheet";
import { useIsMobile } from "~/hooks/use-mobile";
import { cn } from "@workspace/web-ui/lib/utils";
import { Patient } from "../../patient-logs/api/types";

export type EncounterDetailsContentProps = {
    encounter: FormattedEncounter
    className?: string
    patientSummary?: Patient
    program?: string
}

// This component displays the details without the sheet
export const EncounterDetailsContent = ({ encounter, className }: EncounterDetailsContentProps) => {
    return (
        <div className={cn(className)}>
            {encounter.type === "appointment" && <AppointmentDetailsContent encounter={encounter} />}
            {encounter.type === "refill" && <EncounterMedicationRefillDetails encounter={encounter} />}
            {encounter.type === "consultation" && <ConsultationDetailsContent encounter={encounter} />}
        </div>
    )
}

type EncounterDetailsProps = {
    open: boolean;
    onOpenChange: (value: boolean) => void;
    encounter: FormattedEncounter | null
}

export const EncounterDetails = ({ encounter, onOpenChange, open }: EncounterDetailsProps) => {
    const isMobile = useIsMobile()

    return (
        <div className="w-full">
            {/* For larger screens, show directly in the layout */}
            {!isMobile && encounter && (<div className={cn("w-full flex justify-end h-full")}>
                <EncounterDetailsContent className="w-full" encounter={encounter} />
            </div>)}


            {/* For mobile, use Sheet component */}
            {encounter && isMobile && open && <Sheet open={open} onOpenChange={onOpenChange}>
                <SheetContent title="todo-patient-details" side="right"
                    className="flex flex-col gap-6 overflow-y-auto p-0 focus:outline-none w-full">

                    <EncounterDetailsContent className="w-full" encounter={encounter} />
                </SheetContent>
            </Sheet>}

        </div>
    );
}

